{
  "info": "Informações",
  "negative": "Erro",
  "positive": "Sucesso"
}
